import React from "react";
// import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import profile2 from "../../Assets/AppComponent/UDS LOGO BLACK LETTER.png";
const Forms = React.forwardRef((props, ref) => {
  return (
    <>
      <div className="container" ref={ref}>
        <div
          className="employeeformatHeaders row"
          style={{ marginTop: "-20px" }}
        >
          <div className="col-3" style={{ marginRight: "20px" }}>
            <div className="images" style={{ padding: "20px" }}>
              <img
                //   src="https://www.uds.in/webroot/images/uds-logo.svg"
                src={profile2}
                alt="Company Logo."
                style={{ width: "187px", height: "166px" }}
              />
            </div>
          </div>
          <div
            className="col-6 "
            style={{
              width: "80%",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "30px",
            }}
          >
            <p className="companyName" style={{ fontSize: "20px" }}>
              QPMS
              <br />
              <span
                className="companyAddress"
                style={{ width: "670px", display: "block" }}
              >
                No – 2/302A, UDS Salai, Off. Old Mahabalipuram Road,
                Thoraipakkam, Chennai – 600 097.
              </span>
              <br />
              <span
                className="companyContact"
                style={{ width: "720px", display: "block", marginTop: "-30px" }}
              >
                Ph: +91 44 24963234 / 0333 / 0334 Fax: +91 44 40464454 /
                24961912 / 0202
              </span>
              <br />
              <span
                className="companyWeb"
                style={{ marginTop: "-33px", display: "block" }}
              >
                Web:{" "}
                <a  target="_blank">
                  www.qpms.in
                </a>
              </span>
            </p>
          </div>
        </div>

        <div
          className="row Form1PersonalDetails"
          style={{
            border: "1px solid #000",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <div className="col-12" style={{ borderBottom: "1px solid" }}>
            <h3 className="formHeader">Personal Details (Use Capitals):</h3>
          </div>
          <div className="col-12">
            <p>
              <span>Name: wadas</span>
            </p>
            <p>
              (Use CAPITALS) (As it appears in Official Records, Underline
              Surname)
              
            </p>
            {/* <p>Father's / Husband's Name: Ms. sassa</p> */}
            {/* <p>Mother's Name: Ms. sassa</p>
            <p> Date of Birth:10/03/2002 Blood Group:{"A- "}</p>
            <p> Religion: hindu</p>
            <p>Gender</p>
            <p>Marital Status</p> */}
          </div>


          {/* <div className=" Form1PersonalDetailsContent" style={{ marginLeft: "0px", marginRight: "0px" }}> */}

          {/* <div className="col-9">
                <p className="personalDetails">
                  <span>Name: wadas</span>
                  <span>
                    (Use CAPITALS) (As it appears in Official Records, Underline
                    Surname)
                  </span>
                  <br />
                  <span>Father's / Husband's Name: Mr. </span>
                  <br />
                  <span>Mother's Name: Ms. sassa</span>
                  <br />
                  Date of Birth:10/03/2002 Blood Group:{"A- "}
                  Religion: hindu
                  <br />
                  Gender: <span>{"Female"}</span> Marital Status:{" "}
                  <span>{"commited"}</span>
                </p>
              </div> */}
          {/* <div className="col-3">
                <div className="imagesContainer">
                  <img
                    src={profile2}
                    // src="https://www.uds.in/webroot/images/uds-logo.svg"
                    alt="User Photo"
                    className="userPhoto"
                    style={{ width: "100px", height: "100px" }}
                  />
                </div>
              </div> */}
          {/* </div> */}
        </div>

      </div>
    </>
  );
});

export default Forms;
